import { Signal } from '@angular/core';
import { WatchQueryFetchPolicy } from '@apollo/client';
import { BehaviorSubject, Observable } from 'rxjs';

import { InventoryDevice } from '@shure/cloud/shared/models/devices';
import { UpdateResponse } from '@shure/cloud/shared/models/http';

import { DeviceInventoryEvent } from './device-discovery-api.service';

export type DeviceInventoryLoadingStates = 'WaitingToStart' | 'Discovering' | 'WaitingForSnapshots' | 'Done';
export type InventoryLoadingState = {
	state: DeviceInventoryLoadingStates;
	percentComplete: number;
};

export abstract class InventoryDevicesApiService {
	public abstract deviceInventory: BehaviorSubject<InventoryDevice[]>;

	/**
	 * Loading state for inventory devices.
	 */
	public abstract inventoryLoadingState: Signal<InventoryLoadingState>;

	/**
	 * Get # of inventory devices.
	 */
	public abstract getInventoryDevicesCount$(): Observable<number>;

	/**
	 * Get all inventory devices.
	 */
	public abstract getInventoryDevices$(): Observable<DeviceInventoryEvent<InventoryDevice>['allDevices']>;

	/**
	 * Get observable to Inventory device events
	 */
	public abstract getInventoryDeviceEvents$(): Observable<DeviceInventoryEvent<InventoryDevice>['change']>;

	/**
	 * Get inventory device by ID.
	 */
	public abstract getInventoryDevice$(
		deviceId: string,
		fetchPolicy: WatchQueryFetchPolicy
	): Observable<InventoryDevice>;

	/**
	 * Set mute for a device.
	 */
	public abstract setMute(deviceId: string, mute: boolean): Observable<UpdateResponse<void, string>>;

	/**
	 * Set identify for a device.
	 */
	public abstract setIdentify(deviceId: string, identify: boolean): Observable<UpdateResponse<void, string>>;

	/**
	 * Set device name.
	 */
	public abstract setDeviceName(deviceId: string, name: string): Observable<UpdateResponse<void, string>>;
}
